const authPortalMixins = {
  data() {
    return {
      isMounted: false,
      showPassword: false
    };
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    inputFieldErrorMsg(ref) {
      return this.$refs[ref] &&
        !this.$refs[ref].valid &&
        this.$refs[ref].hasInput
        ? this.$refs[ref].errorBucket[0]
        : undefined;
    },
    taggleShowPassword() {
      this.showPassword = !this.showPassword;
    }
  }
};

export default authPortalMixins;
